import React from 'react';
import { Card, Form, Select, Input, Row, Col, Space, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface SelecteesInformationProps {
  form: FormInstance;
}

const SelecteesInformation: React.FC<SelecteesInformationProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];
  const discriminationBasisOptions = [
    'Age', 'Color', 'Mental/Physical Handicap', 'National Origin',
    'Race', 'Religion', 'Reprisal', 'Sex'
  ];

  return (
    <Card title="Selectees' Information" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Were other applicants selected for the position?"
            name={['selectees_info', 'other_applicants_selected']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Were you more qualified than the person selected?"
            name={['selectees_info', 'more_qualified_than_selected']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Were the selected persons selected by the same selecting official?"
            name={['selectees_info', 'same_selecting_official']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Card type="inner" title="Name your coapplicants:">
        <Row gutter={16}>
          <Col span={12}>
            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Names:</div>
          </Col>
          <Col span={12}>
            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Bases:</div>
          </Col>
        </Row>
        <Form.List name={['selectees_info', 'coapplicants']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Row key={key} gutter={16} style={{ marginBottom: 8 }}>
                  <Col span={10}>
                    <Form.Item
                      {...restField}
                      name={[name, 'name']}
                      label={`${name + 1}:`}
                    >
                      <Input placeholder="Enter name" />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      {...restField}
                      name={[name, 'basis']}
                    >
                      <Select placeholder="Select basis">
                        {discriminationBasisOptions.map(option => (
                          <Option key={option} value={option}>{option}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label=" ">
                      <Button
                        type="text"
                        danger
                        icon={<MinusCircleOutlined />}
                        onClick={() => remove(name)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}
              {fields.length < 3 && (
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Coapplicant
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>
      </Card>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Were the persons selected the same basis as you?"
            name={['selectees_info', 'selected_persons_same_basis']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Different selecting official's name:"
            name={['selectees_info', 'different_selecting_official_name']}
          >
            <Input placeholder="Enter name" />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default SelecteesInformation;

